import React from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Row,
  Col
} from "reactstrap";
import "../../styles/estilos.css";
import Page from "components/Page";
import ValoresCotizacion from "../CotizacionAccidentePersonal/ValoresCotizacionAPersonal";
import ListadoProducto from "../CotizacionAccidentePersonal/ListadoProductoAccPersonal";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class CotizacionAccPersonal3 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
        
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          
                  <ListadoProducto/>
            
          </div>
        </div>
      </main>
      
    );
  }
}




const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionAccPersonal3)
);
